// eslint-disable-next-line
import { produce } from 'immer';

const INITIAL_VALUES = {
  id : "",
  ip: "",
  job: "",
  name: "",
  role: "",
  email: "",
  city: "",
  siret: "",
  phone: "",
  avatar: "",
  country: "",
  address: "",
  initial: "",
  zipCode: "",
  firstName: "",
  socialReason: "",
  signature: null,
  authenticated: false,
};

export const SET_JOB = 'SET_JOB';
export const SET_USER = 'SET_USER';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_IP = 'SET_USER_IP';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_CITY = 'SET_USER_CITY';
export const SET_USER_SIRET = 'SET_USER_SIRET';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER_PHONE = 'SET_USER_PHONE';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS';
export const SET_USER_INITIAL = 'SET_USER_INITIAL';
export const SET_USER_ZIP_CODE = 'SET_USER_ZIP_CODE';
export const SET_USER_SIGNATURE = 'SET_USER_SIGNATURE';
export const SET_USER_FIRST_NAME = 'SET_USER_FIRST_NAME';
export const SET_USER_SOCIAL_REASON = 'SET_USER_SOCIAL_REASON';

const userReducer = (state = INITIAL_VALUES, action) =>
// eslint-disable-next-line
  produce(state, draft => {
    switch (action.type) {
      case SET_USER:
        return { ...action.payload };
      case SET_USER_ID:
        draft.id = action.payload;
        break;
      case SET_USER_IP:
        draft.ip = action.payload;
        break;
      case SET_JOB:
        draft.job = action.payload;
        break;
      case SET_USER_ROLE:
        draft.role = action.payload;
        break;
      case SET_USER_NAME:
        draft.name = action.payload;
        break;
      case SET_USER_EMAIL:
        draft.email = action.payload;
        break;
      case SET_USER_AVATAR:
        draft.avatar = action.payload;
        break;
      case SET_USER_FIRST_NAME:
        draft.firstName = action.payload;
        break;
      case SET_USER_CITY:
        draft.city = action.payload;
        break;
      case SET_USER_PHONE:
        draft.phone = action.payload;
        break;
      case SET_USER_SIRET:
        draft.siret = action.payload;
        break;
      case SET_USER_ADDRESS:
        draft.address = action.payload;
        break;
      case SET_USER_INITIAL:
        draft.initial = action.payload;
        break;
      case SET_USER_ZIP_CODE:
        draft.zipCode = action.payload;
        break;
      case SET_USER_COUNTRY:
        draft.country = action.payload;
        break;
      case SET_USER_SIGNATURE:
        draft.signature = action.payload;
        break;
      case SET_USER_SOCIAL_REASON:
        draft.socialReason = action.payload;
        break;
      default:
        return draft;
    }
  });


export default userReducer;
